import { FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";

const AlertMsg = ({ type = "warning", iconView=true, text }) => {
  const styles = {
    warning: {
      backgroundColor: "#fff8e1",
      border: "1px solid #ffe082",
      color: "#5d4400",
      icon: <FaExclamationTriangle style={{ color: "#d17f00", fontSize: "22px", marginRight: "8px" }} />
    },
    info: {
      backgroundColor: "#e3f2fd",
      border: "1px solid #90caf9",
      color: "#0d47a1",
      icon: <FaInfoCircle style={{ color: "#1565c0", fontSize: "22px", marginRight: "8px" }} />
    },
    danger: {
      backgroundColor: "#ffebee",
      border: "1px solid #ef9a9a",
      color: "#b71c1c",
      icon: <FaExclamationTriangle style={{ color: "#c62828", fontSize: "22px", marginRight: "8px" }} />
    }
  };

  const current = styles[type] || styles.warning;

  return (
    <div
      className="mt-1"
      style={{
        backgroundColor: current.backgroundColor,
        padding: "10px 15px",
        borderRadius: "10px",
        border: current.border,
        display: "flex",
        alignItems: "center"
      }}
    >
      {iconView && current.icon}
      <span
        style={{
          color: current.color,
          fontSize: "14px",
          lineHeight: "1.4"
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

export default AlertMsg;
